import { blackColors, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const simpleTableStyle = () => ({
	tableWrapper: {
		width: '100%',
		overflowX: 'auto',
	},
	table: {
		width: 'fit-content',
		minWidth: '100%',
		'& .MuiButtonBase-root': {
			padding: '12px',
			'& svg': {
				width: '16px',
				height: '16px',
			},
			'&:not(.Mui-checked)': {
				'& svg': {
					padding: '7px',
				},
			},
		},
	},
	header: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		backgroundColor: '#fafafa',
		borderBottom: `1px solid ${blackColors[6]}`,
		height: '56px',
		alignItems: 'center',
	},
	whiteHeader: {
		backgroundColor: whiteColor,
	},
	body: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		'& > div': {
			// row
			width: '100%',
			transition: 'all .1s ease-in-out',
			display: 'flex',
			height: '56px',
			alignItems: 'center',
			justifyContent: 'flex-start',
			backgroundColor: whiteColor,
			borderBottom: `1px solid ${blackColors[6]}`,
			'& > div': {
				paddingTop: '4px',
			},
		},
	},
	striped: {
		'& > div': {
			// row
			'&:nth-of-type(2n + 1)': {
				backgroundColor: '#fafafa',
			},
		},
	},
	checkboxWrapper: {
		paddingTop: '0!important',
	},
	rowSelected: {
		backgroundColor: `${blackColors[6]}!important`,
	},
	noResults: {
		marginBottom: 0,
		lineHeight: '40px!important',
		paddingLeft: '12px',
	},
	headerCheckboxWrapper: {
		minWidth: '40px',
	},
	rowDisabled: {
		'& > div': {
			opacity: '0.38',
		},
	},
});

export default simpleTableStyle;
